import http from '@core/fetch'
export default {
  getListApi: body =>
    http('/p/wedding/index.php/admin/APIHotelOrderSub/index', { body }),
  getDetailApi: body =>
    http('/p/wedding/index.php/admin/APIHotelOrderSub/detail', { body }),
  comeMerchantApi: body =>
    http.post('/p/wedding/index.php/Admin/APIHotelOrderSub/come_merchant', {
      body
    }),
  editFollowupApi: body =>
    http.post('/p/wedding/index.php/Admin/APIHotelOrderSub/followup', { body }),
  editSalerApi: body =>
    http.post('/p/wedding/index.php/Admin/APIHotelOrderSub/saler', { body }),
  followFailApi: body =>
    http.post('/p/wedding/index.php/Admin/APIHotelOrderSub/follow_fail', {
      body
    }),
  getHistoryApi: body =>
    http('/p/wedding/index.php/Admin/APIHotelOrderSub/show_history', { body }),
  orderFormApi: body =>
    http.post('/p/wedding/index.php/Admin/APIHotelOrderSub/form_order', {
      body
    })
}
